export { RemoteConfigProvider, ManagedRemoteConfigProvider, } from './remoteConfigProvider';
export { RemoteConfigContext } from './remoteConfigContext';
export * from './connect';
export { useConfiguration, useProperty } from './hooks';
//# sourceMappingURL=index.js.map